<template>
  <span>
    {{ aiMode }}
  </span>
</template>
<script>
import { computed } from "vue";
import { useI18n } from "vue-i18n";

export default {
  props: {
    aiLevel: {
      type: String,
      require: true,
    },
  },
  setup(props) {
    const { t } = useI18n();
    const aiMode = computed(() => {
      if (props.aiLevel == "High") {
        return t("devices.highAILevel");
      } else if (props.aiLevel == "Mid") {
        return t("devices.midAILevel");
      } else if (props.aiLevel == "Low") {
        return t("devices.lowAILevel");
      } else {
        return t("devices.defaultAILevel");
      }
    });
    return {
      aiMode,
    };
  },
};
</script>
